import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from '../../components/Loader';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';
import { ROUTES } from '../consts';

type FeatureFlagProtectedRouteProps = PropsWithChildren<{
  featureId: string;
  requireOrganizationOwner?: boolean;
  fallbackTo?: string;
}>;

export const FeatureFlagProtectedRoute = ({
  children,
  featureId,
  requireOrganizationOwner = false,
  fallbackTo = ROUTES.ROOT,
}: FeatureFlagProtectedRouteProps) => {
  const { canAccess, isLoading } = useFeatureAccess({
    featureId,
    options: { requireOrganizationOwner },
  });

  if (isLoading) {
    return <Loader center />;
  }

  if (!canAccess) {
    console.warn("You're not allowed to access this page");

    return <Navigate to={fallbackTo} replace />;
  }

  return <>{children}</>;
};
